// extracted by mini-css-extract-plugin
module.exports = {"placeholderColor":"modalDetail_placeholderColor__2wt_D"};